import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { SaturationBox } from "./components/SaturationBox.js";
import { SaturationCursor } from "./components/SaturationCursor.js";
const Saturation = forwardRef(function Saturation2(props, ref) {
  const { cursor, ...rest } = props;
  return /* @__PURE__ */ jsx(SaturationBox, { ...rest, ref, testId: "TidalColorPickerSaturation", children: /* @__PURE__ */ jsx(SaturationCursor, { style: { ...cursor }, "data-testid": "TidalColorPickerSaturationCursor" }) });
});
export {
  Saturation
};
//# sourceMappingURL=Saturation.js.map
